import { Link } from "react-router-dom";
import { Sparkles, Trash2 } from "lucide-react";

/**
 * "Progress & reports" + "Danger zone" — the two short, fully self-contained
 * sections at the bottom of Settings. Extracted so Settings.jsx stays under
 * 1100 lines and these can be unit-tested in isolation.
 *
 * Both sections only need a couple props. No state lives here.
 */

export function ProgressReportsSection({ profile, profileId }) {
  if (!profile) return null;
  return (
    <section className="brutal-card bg-white p-5 mb-4">
      <h2 className="display text-xl font-bold mb-2">Progress &amp; reports</h2>
      <p className="text-[color:var(--ink-soft)] mb-3">
        See how {profile.name}'s vocabulary is growing — top tiles, days active,
        and a 30-day chart. Print or screenshot for a caregiver conversation.
      </p>
      <Link
        to={`/report/${profileId}`}
        className="pill-btn primary"
        data-testid="settings-open-report"
      >
        <Sparkles size={16} /> Open progress report
      </Link>
    </section>
  );
}

export function DangerZoneSection({ onDeleteAccount }) {
  return (
    <section
      className="brutal-card bg-white p-5 mb-4 border-[color:var(--coral)]"
      data-testid="danger-zone"
    >
      <h2 className="display text-xl font-bold mb-2 text-[color:var(--coral-deep)]">
        Danger zone
      </h2>
      <p className="text-[color:var(--ink-soft)] mb-3">
        Permanently delete your account and every board you own. We can't
        recover this.
      </p>
      <button
        type="button"
        className="pill-btn danger"
        onClick={onDeleteAccount}
        data-testid="settings-delete-account"
      >
        <Trash2 size={16} /> Delete my account forever
      </button>
    </section>
  );
}
